import { useContext } from "react";
import { CellContext } from "./CellProvider";

export default function useCellContext() {
    return useContext(CellContext);
};
